import React, { PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAtom } from 'jotai';

import { isAutoDecisioningAdminHubPath } from '@/hooks/facility-selection/screenerFacilityTypeHelpers';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import {
  ALL_FACILITIES,
  selectedFacilityIdAtom
} from '@/hooks/useFacilitiesQuery';

export const CrmRequireSelectedFacility: React.FC<PropsWithChildren> = ({
  children
}) => {
  const { pathname } = useLocation();
  const isAutoDecisioningRoute = isAutoDecisioningAdminHubPath(pathname);
  const { data: currentUser } = useCurrentUser();
  const [selectedFacilityId, setSelectedFacilityId] = useAtom(
    selectedFacilityIdAtom
  );

  useEffect(() => {
    if (selectedFacilityId === ALL_FACILITIES && !isAutoDecisioningRoute) {
      setSelectedFacilityId(currentUser?.facility_id!);
    }
  }, [
    selectedFacilityId,
    currentUser?.facility_id,
    setSelectedFacilityId,
    isAutoDecisioningRoute
  ]);

  if (selectedFacilityId === ALL_FACILITIES && !isAutoDecisioningRoute) {
    return null;
  }

  return <>{children}</>;
};
